import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authClient, useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { sfx } from "@/lib/sounds";

const TOKEN_KEY = "lostdc:token";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (!code) {
      navigate("/", { replace: true });
      return;
    }
    const redirectUri = window.location.origin + "/auth/google";
    (async () => {
      try {
        const { data } = await authClient.post("/auth/google/exchange", { code, redirect_uri: redirectUri });
        if (data.token) localStorage.setItem(TOKEN_KEY, data.token);
        await refresh();
        sfx.levelup();
        toast.success("Signed in with Google");
        window.history.replaceState(null, "", "/profile");
        navigate("/profile", { replace: true });
      } catch (err) {
        sfx.error();
        toast.error("Google sign-in failed");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-black text-white" data-testid="google-callback">
      <div className="rounded-2xl glass px-8 py-6 flex items-center gap-3">
        <span className="w-3 h-3 rounded-full bg-[#FFBF00] animate-pulse" />
        <span className="text-sm uppercase tracking-widest">Completing Google sign-in…</span>
      </div>
    </div>
  );
}
